/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { jsx, cssMap as unboundedCssMap } from '@compiled/react';
import { FormattedMessage, type MessageDescriptor } from 'react-intl-next';

import { cssMap, cx } from '@atlaskit/css';
import Image from '@atlaskit/image';
import { Anchor, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const unboundedStyles = unboundedCssMap({
	container: {
		display: 'flex',
		backgroundColor: token('color.background.input'),
		overflow: 'hidden',
		height: '100%',
		width: '100%',
	},
	image: {
		backgroundColor: token('color.background.accent.gray.subtlest'),
	},
});

const styles = cssMap({
	body: {
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
		font: token('font.body'),
	},
	link: {
		color: token('color.text.subtle'),
	},
});

export type SmallErrorStateProps = {
	heading: MessageDescriptor;
	hideLink?: boolean;
	image: string;
	link?: string;
	subheading?: MessageDescriptor;
};

export const SmallErrorState = ({
	image,
	heading,
	subheading,
	link,
	hideLink,
}: SmallErrorStateProps) => {
	return (
		<div css={unboundedStyles.container}>
			{/* eslint-disable-next-line @atlassian/a11y/alt-text -- See https://go/a11y-alt-text for more details */}
			<Image src={image} css={unboundedStyles.image} />
			<Stack xcss={cx(styles.body)} alignBlock="center">
				<Text weight="medium">
					<FormattedMessage {...heading} />
				</Text>
				{!!subheading && !hideLink && (
					<Anchor href={link || '#'} target="_blank" xcss={cx(styles.link)}>
						<FormattedMessage {...subheading} />
					</Anchor>
				)}
			</Stack>
		</div>
	);
};
